export interface ColorTokens {
  surface: {
    base: string;
    raised: string;
    sunken: string;
    overlay: string;
  };
  text: {
    primary: string;
    secondary: string;
    muted: string;
    onAccent: string;
    onDanger: string;
  };
  border: {
    subtle: string;
    default: string;
    strong: string;
    focus: string;
  };
  accent: {
    default: string;
    hover: string;
    pressed: string;
    soft: string;
  };
  status: {
    success: { bg: string; fg: string };
    warning: { bg: string; fg: string };
    danger: { bg: string; fg: string };
    info: { bg: string; fg: string };
  };
}

export interface ModeTokens {
  light: ColorTokens;
  dark: ColorTokens;
}

export const radius = {
  sm: '6px',
  md: '10px',
  lg: '14px',
  pill: '999px',
} as const;

export const space = {
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
  16: '64px',
} as const;

export const fontSize = {
  xs: '12px',
  sm: '14px',
  base: '16px',
  lg: '18px',
  xl: '22px',
  '2xl': '28px',
  '3xl': '36px',
} as const;

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
} as const;

export const duration = {
  fast: '120ms',
  base: '200ms',
  slow: '320ms',
} as const;

export const ease = {
  out: 'cubic-bezier(.2,.8,.2,1)',
  in: 'cubic-bezier(.4,0,1,1)',
  inOut: 'cubic-bezier(.4,0,.2,1)',
} as const;

export const fontFamily = {
  sans: "'Quicksand', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  mono: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
} as const;
